import { GenericMedicalList } from "./GenericMedicalList";

const PREGNANCY_STATUSES = ["Not Pregnant", "Pregnant", "Postpartum", "Not Applicable", "Unknown"];
const CONTRACEPTION = [
  "None", "Oral Contraceptive", "IUD (Hormonal)", "IUD (Copper)", "Contraceptive Implant",
  "Depo-Provera Injection", "Contraceptive Patch", "Vaginal Ring", "Condoms", "Diaphragm",
  "Tubal Ligation", "Vasectomy (partner)", "Fertility Awareness", "Withdrawal", "Abstinence",
];
const MENSTRUAL_STATUS = ["Regular", "Irregular", "Amenorrhea", "Perimenopause", "Postmenopause"];

const DEFAULT = {
  recorded_at: new Date().toISOString().slice(0, 10),
  pregnancy_status: "Not Applicable", lmp_date: "", edd_date: "",
  gravida: "", para: "", term: "", preterm: "", abortus: "", living: "",
  contraception_method: "None", menstrual_status: "",
  last_pap_date: "", last_mammogram_date: "", partners_last_12mo: "",
  notes: "",
};

const COLUMNS = [
  { key: "recorded_at", label: "Recorded", format: "date" },
  { key: "pregnancy_status", label: "Pregnancy Status", format: "chip" },
  { key: "lmp_date", label: "LMP", format: "date" },
  { key: "contraception_method", label: "Contraception" },
  { key: "menstrual_status", label: "Menstrual Status" },
];

const FIELDS = [
  { key: "recorded_at", label: "Recorded Date", type: "date", required: true },
  { key: "pregnancy_status", label: "Pregnancy Status", type: "select", options: PREGNANCY_STATUSES, required: true },
  { key: "lmp_date", label: "Last Menstrual Period", type: "date" },
  { key: "edd_date", label: "Estimated Due Date", type: "date" },
  { key: "gravida", label: "Gravida (total pregnancies)", type: "number" },
  { key: "para", label: "Para (births)", type: "number" },
  { key: "term", label: "Term deliveries", type: "number" },
  { key: "preterm", label: "Preterm deliveries", type: "number" },
  { key: "abortus", label: "Abortions or Losses", type: "number" },
  { key: "living", label: "Living children", type: "number" },
  { key: "contraception_method", label: "Contraception", type: "select", options: CONTRACEPTION },
  { key: "menstrual_status", label: "Menstrual Status", type: "select", options: MENSTRUAL_STATUS },
  { key: "last_pap_date", label: "Last Pap", type: "date" },
  { key: "last_mammogram_date", label: "Last Mammogram", type: "date" },
  { key: "partners_last_12mo", label: "Partners (last 12 months)", type: "number" },
  { key: "notes", label: "Notes", type: "textarea", span: 2 },
];

export default function ReproductiveHealth({ client }) {
  return (
    <GenericMedicalList
      client={client}
      title="Reproductive Health"
      subtitle="Pregnancy status, LMP, contraception, GTPAL, and reproductive screenings."
      endpointList={(cid) => `/clients/${cid}/reproductive-health`}
      endpointCreate={(cid) => `/clients/${cid}/reproductive-health`}
      endpointUpdate={(id) => `/reproductive-health/${id}`}
      endpointDelete={(id) => `/reproductive-health/${id}`}
      columns={COLUMNS}
      formFields={FIELDS}
      defaultForm={DEFAULT}
      testPrefix="reproductive-health"
      emptyText="No reproductive health entries recorded"
    />
  );
}
